namespace TabAurous.Retail {
    export namespace ReceiptSelectService {
        export const baseUrl = 'Retail/ReceiptSelect';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<ReceiptRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Retail/ReceiptSelect/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>ReceiptSelectService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
